import { createClient } from "./requests.js";
let token = "";
// ==================== READ ====================

function getUSPatentApplication(id) {
  const request = createClient(token);
  return request.get(`/application?id=${id}`);
}

function getIssuedPatentMaintenanceData(applId, patentNum) {
  const request = createClient(token);
  return request.get(
    `/application/maintenance?applicationNumber=${applId}&patentNumber=${patentNum}`
  );
}

function getUSPatAppbyCustNum(custnum, start = 0) {
  const request = createClient(token);
  return request
    .get(`/application/customer-number?id=${custnum}&start=${start}`)
    .catch((error) => {
      console.log("error in get pat app by custom " + error);
      return null;
    });
}

function getUSPatentApplicationCmsData(id) {
  const request = createClient(token);
  return request.get(`/application/cmsData?id=${id}`).catch((error) => {
    console.log("error in get cms " + error);
    return null;
  });
}

function getUSPatentApplicationIfwData(id) {
  const request = createClient(token);
  return request.get(`/application/ifw?id=${id}`).catch((error) => {
    console.log("error in get ifw data " + error);
    return null;
  });
}

function downloadDocument(firm_id, applId, docId) {
  const request = createClient(token);
  return request.get(
    `/download/pdf?firm_id=${firm_id}&id=${applId}&docId=${docId}`
  );
}

function downloadDocumentByDownloadUrl(firm_id, applId, downloadUrl) {
  const request = createClient(token);
  return request.post("/download/document", {
    firm_id: firm_id,
    id: applId,
    downloadUrl: downloadUrl,
  });
}

function enqueuePrivatePair(firm_id, customer_number) {
  const request = createClient(token);
  return request.post("/ppair", {
    customer_number: customer_number,
    firm_id: firm_id,
  });
}

function enqueuePrivatePairPatent(firm_id, patent_number) {
  const request = createClient(token);
  return request.post("/ppair", {
    patent_number: patent_number,
    firm_id: firm_id,
  });
}

function sendInvites(firm_id) {
  const request = createClient(token);
  return request.post("/invites/send_invites", {
    firm_id: firm_id,
  });
}

function acceptInvite(invite_id, firm_id) {
  const request = createClient(token);
  return request.post("/invites/accept_invite", {
    invitation_id: invite_id,
    firm_id: firm_id,
  });
}

function countPendingPatents(customer_numbers) {
  const request = createClient(token);
  return request.get("/customerNumberCount", {
    params: { customerNumbers: customer_numbers },
  });
}

function sendXml(firm_id, xml_data) {
  const request = createClient(token);
  return request.post("/xmlImport", { firm_id: firm_id, xml_data: xml_data });
}

function addLLM(firm_id, llm_name, llm_api_key) {
  const request = createClient(token);
  return request.post("/llm-setup/add-llm", {
    firm_id: firm_id,
    llm_name: llm_name,
    llm_api_key: llm_api_key,
  });
}

function deleteLLM(firm_id, llm_name) {
  const request = createClient(token);
  return request.post("/llm-setup/delete-llm", {
    firm_id: firm_id,
    llm_name: llm_name,
  });
}

function getReferencesAndCitations(firm_id, document_id, xml_data) {
  const request = createClient(token);
  return request.post("/office-action/getReferencesAndCitations", {
    firm_id: firm_id,
    document_id: document_id,
    xml_data: xml_data,
  });
}

function generateClaimChart(firm_id, document_id, xml_data) {
  const request = createClient(token);
  return request.post("/office-action/generateClaimChart", {
    firm_id: firm_id,
    document_id: document_id,
    xml_data: xml_data,
  });
}

function getClaimChart(firm_id, document_id) {
  const request = createClient(token);
  return request.get("/office-action/claimChart", {
    params: { firm_id: firm_id, document_id: document_id },
  });
}

function updateClaimChartRow(firm_id, document_id, rowId, updates) {
  const request = createClient(token);
  const body = { firm_id: firm_id, document_id: document_id };
  if (Object.prototype.hasOwnProperty.call(updates, "referenceNumber")) {
    body.referenceNumber = updates.referenceNumber;
  }
  if (Object.prototype.hasOwnProperty.call(updates, "userReview")) {
    body.userReview = updates.userReview;
  }
  return request.patch(
    `/office-action/claimChart/${encodeURIComponent(rowId)}`,
    body
  );
}

function verifyClaimChartCitation(
  firm_id,
  document_id,
  rowId,
  referenceNumber
) {
  const request = createClient(token);
  return request.post(
    `/office-action/claimChart/${encodeURIComponent(rowId)}/verifyCitation`,
    {
      firm_id: firm_id,
      document_id: document_id,
      referenceNumber: referenceNumber,
    }
  );
}

function reverifyClaimChartCitation(
  firm_id,
  document_id,
  rowId,
  referenceNumber,
  disputeNote
) {
  const request = createClient(token);
  return request.post(
    `/office-action/claimChart/${encodeURIComponent(rowId)}/reverifyCitation`,
    {
      firm_id: firm_id,
      document_id: document_id,
      referenceNumber: referenceNumber,
      disputeNote: disputeNote,
    }
  );
}

function draftOAResponse(summary, explanation, firm_id, document_id) {
  const request = createClient(token);
  return request.post("/office-action/analyze", {
    firm_id: firm_id,
    document_id: document_id,
    summary: summary,
    explanation: explanation,
  });
}

function streamOAAnalysis(firm_id, document_id, options = {}) {
  const request = createClient(token);
  return request.postEventStream(
    "/office-action/stream",
    {
      firm_id: firm_id,
      document_id: document_id,
    },
    options
  );
}

function oaChat(
  firm_id,
  document_id,
  chat_history_id,
  user_prompt,
  system_instruction,
  llm_name,
  llm_model,
  context = [],
  options = {}
) {
  const request = createClient(token);
  console.log("Sending OA chat request with context:", context);
  return request.postEventStream(
    "/office-action/chat",
    {
      firm_id: firm_id,
      document_id: document_id,
      session_id: token,
      chat_history_id: chat_history_id,
      user_prompt: user_prompt,
      system_instruction: system_instruction,
      llm_name: llm_name,
      llm_model: llm_model,
      context: context,
    },
    options
  );
}

function parseIdsPdf(firm_id, applId, storagePath) {
  const request = createClient(token);
  return request.post("/ids/parse-ids-pdf", {
    firm_id: firm_id,
    applId: applId,
    storagePath: storagePath,
  });
}

function parseOaPdf(firm_id, applId, file) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("firm_id", firm_id);
  formData.append("applId", applId);
  const request = createClient(token);
  return request.post("/ids/parse-oa-pdf", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function parseClaimsPdf(firm_id, file) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("firm_id", firm_id);
  const request = createClient(token);
  return request.post("/office-action/parse-claims-pdf", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function downloadIdsReference(firm_id, reference_id, pdfUrl) {
  const request = createClient(token);
  return request.post("/ids/download-reference", {
    firm_id,
    reference_id,
    pdfUrl,
  });
}

function parseRefPdfs(firm_id, applId, files) {
  const formData = new FormData();
  for (const file of files) {
    formData.append("files", file);
  }
  formData.append("firm_id", firm_id);
  formData.append("applId", applId);
  const request = createClient(token);
  return request.post("/ids/parse-ref-pdfs", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function lookupReferences(firm_id, applId, referenceNumbers) {
  const request = createClient(token);
  return request.post("/ids/lookup-references", {
    firm_id,
    applId,
    reference_numbers: referenceNumbers,
  });
}

function uploadPriorArtReferences(firm_id, applId, files) {
  const formData = new FormData();
  for (const file of files) {
    formData.append("files", file);
  }
  formData.append("firm_id", firm_id);
  formData.append("applId", applId);
  const request = createClient(token);
  return request.post("/prior-art/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function scorePriorArtReference(firm_id, applId, reference_id, claims = []) {
  const request = createClient(token);
  return request.post("/prior-art/score", {
    firm_id,
    applId,
    reference_id,
    claims,
  });
}

function generateInvalidationClaimChart(
  firm_id,
  applId,
  primary_reference_id,
  secondary_reference_ids = [],
  invalidation_type = "102",
  claims = []
) {
  const request = createClient(token);
  return request.post("/prior-art/generate-invalidation-chart", {
    firm_id,
    applId,
    primary_reference_id,
    secondary_reference_ids,
    invalidation_type,
    claims,
  });
}

function downloadReference(firm_id, document_id, patent_number) {
  const request = createClient(token);
  return request.post("/office-action/getReferenceByPatentNumber", {
    firm_id: firm_id,
    document_id: document_id,
    patent_number: patent_number,
  });
}

function uploadReferencePdf(firm_id, document_id, reference_id, file) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("firm_id", firm_id);
  formData.append("document_id", document_id);
  formData.append("reference_id", reference_id);
  const request = createClient(token);
  return request.post("/upload/uploadReferencePdf", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function setAuthToken(id) {
  token = id;
}

// exposes the current ID token for non-axios HTTP layers (rest-firestore)
function getAuthToken() {
  return token;
}

// Patensys v2: currently only changeSubscription is used.
function cancelSubscription(sub_id, firm_id) {
  const request = createClient(token);
  return request.post("/changeSubscription/cancel", {
    subId: sub_id,
    firmId: firm_id,
  });
}

function changeSubscription(sub_id, firm_id, items) {
  const request = createClient(token);
  return request.post("/changeSubscription/change", {
    subId: sub_id,
    firmId: firm_id,
    items: items,
  });
}

function importApplicationById(firm_id, applId) {
  const request = createClient(token);
  return request.post("/publicapplication", {
    firm_id: firm_id,
    application_number: applId,
  });
}

function downloadTmDoc(firm_id, serial_number, doc_id) {
  const request = createClient(token);
  return request.post("/trademark/download-doc", {
    firm_id: firm_id,
    serial_number: serial_number,
    doc_id: doc_id,
  });
}

function addManualFamilyRelation(
  firm_id,
  applIdA,
  applIdB,
  ipOfficeNameA,
  ipOfficeNameB
) {
  const request = createClient(token);
  const body = { firm_id, applIdA, applIdB };
  if (ipOfficeNameA) body.ipOfficeNameA = ipOfficeNameA;
  if (ipOfficeNameB) body.ipOfficeNameB = ipOfficeNameB;
  return request.post("/family-tree/manual-relations", body);
}

function deleteManualFamilyRelation(
  firm_id,
  applIdA,
  applIdB,
  ipOfficeNameA,
  ipOfficeNameB
) {
  const request = createClient(token);
  const body = { firm_id, applIdA, applIdB };
  if (ipOfficeNameA) body.ipOfficeNameA = ipOfficeNameA;
  if (ipOfficeNameB) body.ipOfficeNameB = ipOfficeNameB;
  return request.delete("/family-tree/manual-relations", { data: body });
}

// ==================== litigation module ====================
// Real backend surface (see docs/architecture/litigation-module-plan.md and
// the backend API spec). All under /litigation, auth via `token` header.

// PACER case metadata lookup (billable). 404 = not found;
// 401 { needsOtp } = PACER session expired for MFA accounts.
function lookupLitigationCase(firm_id, case_number, court) {
  const request = createClient(token);
  return request.get(
    `/litigation/case-lookup?firm_id=${firm_id}&case_number=${encodeURIComponent(
      case_number
    )}&court=${encodeURIComponent(court)}`
  );
}

// intake: send complaint PDF, get back an intakeProposal for the prefill
// form. Nothing persisted.
function extractLitigationComplaint(firm_id, file) {
  const request = createClient(token);
  const formData = new FormData();
  formData.append("firm_id", firm_id);
  formData.append("complaint", file);
  return request.post("/litigation/cases/from-complaint", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

// staff PDF upload into the case record. destination "court" ->
// courtDocuments; default -> restrictedDocuments. No share option at upload.
function uploadLitigationDocument(firm_id, case_id, file, title, destination) {
  const request = createClient(token);
  const formData = new FormData();
  formData.append("firm_id", firm_id);
  formData.append("case_id", case_id);
  formData.append("file", file);
  if (title) formData.append("title", title);
  if (destination) formData.append("destination", destination);
  return request.post("/litigation/documents/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

// (re)run DCO/standing-order extraction on a PROCESSED court doc ->
// { proposal }, persisted on the doc (extractionStatus: "proposed")
function extractLitigationDco(firm_id, case_id, document_id, mode = "dco") {
  const request = createClient(token);
  return request.post("/litigation/dco/extract", {
    firm_id,
    case_id,
    document_id,
    mode,
  });
}

// sync DCO extraction: send the PDF directly, get the proposal in the
// response — no Firestore doc needed first, no pipeline race. After staff
// confirm (POST /dco/confirm), attach the PDF for the record separately via
// /documents/upload. Used by the "I have the DCO in hand" upload UX.
// multipart fields: firm_id, case_id, file (the PDF), mode ("dco"|"standing")
function extractLitigationDcoUpload(firm_id, case_id, file, mode = "dco") {
  const request = createClient(token);
  const formData = new FormData();
  formData.append("firm_id", firm_id);
  formData.append("case_id", case_id);
  formData.append("file", file);
  formData.append("mode", mode);
  return request.post("/litigation/dco/extract-upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

// staff confirm the DCO schedule (optionally edited) -> backend creates the
// litigationDocketing tasks from it
function confirmLitigationDco(firm_id, case_id, document_id, proposal) {
  const request = createClient(token);
  return request.post("/litigation/dco/confirm", {
    firm_id,
    case_id,
    document_id,
    ...(proposal ? { proposal } : {}),
  });
}

// confirm/adjust an auto-generated docketing task (deadline/title optional)
function confirmLitigationTask(firm_id, taskId, adjustments = {}) {
  const request = createClient(token);
  return request.post("/litigation/docketing/confirm", {
    firm_id,
    taskId,
    ...adjustments,
  });
}

// resolved rule table for the case-setup screen (layered merge already done)
function getResolvedRuleSets(firm_id, case_id) {
  const request = createClient(token);
  return request.get(
    `/litigation/rulesets/resolved?firm_id=${firm_id}&case_id=${case_id}`
  );
}

// discovery intake: party-served papers never hit PACER — extract the set
// from the served PDF. Returns { proposal: { direction, type, setNumber,
// servingParty, servedDate, items: [{ itemNumber, title, title_zh, text,
// text_zh }] } }. Nothing persisted.
function extractLitigationDiscovery(firm_id, case_id, file) {
  const request = createClient(token);
  const formData = new FormData();
  formData.append("firm_id", firm_id);
  formData.append("case_id", case_id);
  formData.append("file", file);
  return request.post("/litigation/discovery/extract-upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

// confirm the extracted discovery set -> backend creates one discoveryItems
// doc per request (dedup: existing items in the set are skipped — safe to
// re-confirm). Items start status "open", sharedWithClient false.
// direction is TOP-LEVEL (not inside proposal): "received" | "propounded" —
// who served the set; the extractor's guess can be wrong.
function confirmLitigationDiscovery(
  firm_id,
  case_id,
  proposal,
  direction,
  response_due
) {
  const request = createClient(token);
  return request.post("/litigation/discovery/confirm", {
    firm_id,
    case_id,
    proposal,
    direction,
    ...(response_due ? { response_due } : {}),
  });
}

// pull the docket sheet from PACER, creating one courtDocuments record per
// entry (no PDFs). BILLABLE (~$0.10/page) — the UI confirms first.
// 409 = case has no pacerCaseId (run case-lookup first).
// Returns { created, skipped, total }.
function syncLitigationDocket(firm_id, case_id) {
  const request = createClient(token);
  return request.post("/litigation/sync/docket", { firm_id, case_id });
}

// the ONLY file-read path: returns a short-lived signed URL (audited).
// kind: courtDocument | restrictedDocument | draftVersion | discoveryItem |
// pipelineText; artifact: pdf | translation (for pipelineText)
function downloadLitigationFile(firm_id, case_id, kind, id, extra = {}) {
  const request = createClient(token);
  return request.post("/litigation/download", {
    firm_id,
    case_id,
    kind,
    id,
    ...extra,
  });
}

// staff "fetch from PACER": downloads the entry's PDF via its doc1 id (billable,
// recorded on the doc as fetchCostUsd/fetchBillablePages). No confirmation flow —
// the click is the intent. Returns { storagePath, bytes, fetchCostUsd } or
// { storagePath, alreadyHad: true } when the file was already pulled.
function fetchLitigationDocument(firm_id, case_id, document_id, attachment_pacer_doc_id = null, process = false) {
  const request = createClient(token);
  return request.post("/litigation/documents/fetch", {
    firm_id,
    case_id,
    document_id,
    ...(attachment_pacer_doc_id ? { attachment_pacer_doc_id } : {}),
    ...(process ? { process: true } : {}),
  });
}

// on-demand translation for a fetched doc whose pipeline already ran but has no
// translatedTextPath (decided design; endpoint lands with the backend build)
function translateLitigationDocument(firm_id, case_id, document_id, attachment_pacer_doc_id = null) {
  const request = createClient(token);
  return request.post("/litigation/documents/translate", {
    firm_id,
    case_id,
    document_id,
    ...(attachment_pacer_doc_id ? { attachment_pacer_doc_id } : {}),
  });
}

// client-safe text extraction (no classification/proposals) — the mechanical
// first pipeline step; lights up the translate button for a client-fetched doc
// without waiting for staff processing. Idempotent (alreadyHad).
function extractLitigationText(firm_id, case_id, document_id) {
  const request = createClient(token);
  return request.post("/litigation/documents/extract", {
    firm_id,
    case_id,
    document_id,
  });
}

// semantic search over the case's embedded chunks (Stage 1) -> ranked passages
// with document provenance (citation-first; no synthesized answer)
function searchLitigationCase(firm_id, case_id, query, limit = 10) {
  const request = createClient(token);
  return request.post("/litigation/search", { firm_id, case_id, query, limit });
}

// staff confirms a trigger event; the rules engine generates the dependent
// (unconfirmed) deadline tasks — works for case-local trigger slugs too
function confirmLitigationTrigger(firm_id, litigationCaseId, trigger) {
  const request = createClient(token);
  return request.post("/litigation/triggers/confirm", {
    firm_id,
    litigationCaseId,
    ...trigger,
  });
}

// case rule overrides (Rules tab): list / upsert (keyed by ruleId) / delete
function getRuleOverrides(firm_id, case_id) {
  const request = createClient(token);
  return request.get("/litigation/rules/overrides", { params: { firm_id, case_id } });
}
function upsertRuleOverride(firm_id, case_id, override) {
  const request = createClient(token);
  return request.put("/litigation/rules/overrides", { firm_id, case_id, override });
}
function deleteRuleOverride(firm_id, case_id, ruleId) {
  const request = createClient(token);
  return request.delete("/litigation/rules/overrides", { data: { firm_id, case_id, ruleId } });
}

// reject a proposed extraction (DCO/order) — clears it from the pending-review
// queue; the doc stays processed
function rejectLitigationExtraction(firm_id, case_id, document_id) {
  const request = createClient(token);
  return request.post("/litigation/dco/reject", {
    firm_id,
    case_id,
    document_id,
  });
}

export {
  setAuthToken,
  getAuthToken,
  lookupLitigationCase,
  extractLitigationComplaint,
  uploadLitigationDocument,
  extractLitigationDco,
  extractLitigationDcoUpload,
  confirmLitigationDco,
  confirmLitigationTask,
  getResolvedRuleSets,
  extractLitigationDiscovery,
  confirmLitigationDiscovery,
  syncLitigationDocket,
  downloadLitigationFile,
  fetchLitigationDocument,
  translateLitigationDocument,
  extractLitigationText,
  searchLitigationCase,
  rejectLitigationExtraction,
  confirmLitigationTrigger,
  getRuleOverrides,
  upsertRuleOverride,
  deleteRuleOverride,
  getUSPatentApplication,
  getIssuedPatentMaintenanceData,
  downloadDocument,
  getUSPatAppbyCustNum,
  getUSPatentApplicationCmsData,
  enqueuePrivatePair,
  enqueuePrivatePairPatent,
  getUSPatentApplicationIfwData,
  sendInvites,
  acceptInvite,
  countPendingPatents,
  sendXml,
  downloadDocumentByDownloadUrl,
  getReferencesAndCitations,
  generateClaimChart,
  getClaimChart,
  updateClaimChartRow,
  verifyClaimChartCitation,
  reverifyClaimChartCitation,
  addLLM,
  deleteLLM,
  cancelSubscription,
  changeSubscription,
  draftOAResponse,
  streamOAAnalysis,
  oaChat,
  downloadReference,
  uploadReferencePdf,
  importApplicationById,
  parseIdsPdf,
  parseOaPdf,
  parseClaimsPdf,
  downloadIdsReference,
  parseRefPdfs,
  lookupReferences,
  uploadPriorArtReferences,
  scorePriorArtReference,
  generateInvalidationClaimChart,
  downloadTmDoc,
  addManualFamilyRelation,
  deleteManualFamilyRelation,
};
